<template>
  <div class="exhibitionRecord"  id="jobListDiv">
    <el-col class="userinfoList infoPub" style="width: 990px">
      <div class="exhContent">
        <!-- 搜索组件 -->
<!--        <search-bar-->
<!--          :selectType="ExhIndexType"-->
<!--          :searchInputPlc="searchInputPlc"-->
<!--          :searchSelectPlc="searchSelectPlc"-->
<!--          @changeExhibitionState="toSearch"-->
<!--          @toSearch="toSearch"-->
<!--        ></search-bar>-->
        <!--提示信息-->
        <div class="prompt-info-wrap ji-tip">
          <div
            class="prompt-info"
            v-if="lan == 'ch'"
          >
            1、参展前，请确保您使用的参展电脑配有摄像头，耳机和麦克风设备。
          </div>
          <div
            class="prompt-info"
            v-if="lan == 'ch'"
          >
            2、参展时，请使用谷歌浏览器打开展会官网，如需安装，<span
              class="download"
              @click="download"
            >
              {{ language.down }}
            </span>
          </div>
        </div>
        <!-- content -->
        <resume-info ref="resumeInfo" flagType="edit"></resume-info>
        <!-- page -->


      </div>
    </el-col>
    <el-dialog
      :visible="showShare"
      :title="language.ShareTicket"
      @update:visible="updateVisiable($event)"
      width="1000px"
      :show-close="true"
      class="hint_dialog"
    >
      <div class="share-title">{{language.Sharelinks}}</div>
      <div class="pc-url-div">
        <p id="copy_pc_url">{{shareLink}}</p>
      </div>
      <div class="url-formBtn">
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="copyPcUrl"
          v-if="lan == 'ch'"
          >复制</el-button
        >
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="copyPcUrl"
          v-else
          >Copy</el-button
        >
      </div>
      <div class="share-title">{{language.appletCode}}</div>
      <div style="padding-top:10px;">{{language.appletContent}}</div>
      <div >
        <img class="share-img" :src="shareWxQr"/>
      </div>
      <div class="url-formBtn" style="margin-top: 20px;border-bottom:0;">
        <el-button
          type="warning"
          class="pc-url-formBtn"
          @click.native="imgDown(shareWxQr)"
         >{{language.download}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {MessageBox} from 'element-ui';
import { language } from "../../../language/get";
import { ExhIndexType } from "../../../common/constant/exhibition";
import { getGzExhTicketList, ExhticketRecovery } from "../../../api/tickets";
import { ExhibitionType } from "../../../common/constant/exhibition";
import searchBar from "../components/searchbar/searchbar";
import pubTable from "../components/table/table";
import tablePage from "../components/tablepage/tablepage";
const pubLanguage = language();
import Cookies from "../../../common/cookie";
import { getBroadcastClass } from "../../../api/exhibition";
import Axios from "axios";
import reqest from "../../../common/reqest";
import {mapGetters} from "vuex";
import {findJogList} from "@/api/btManage";
import resumeInfo from "@/pages/user/onlineResume/resumeInfo";

export default {
  components: {
    resumeInfo,
    searchBar,
    pubTable,
    tablePage,
  },
  data() {
    return {
      a:[0, 1],
      defaultImg: 'this.src="' + require('@/assets/ic_pdf.png') + '"',
      txDefaultImg: 'this.src="' + require('@/assets/img/tx.png') + '"',
      city:[],
      cityPost:[], //应聘城市
      jobPost:[], //求职意向
      postCount:0, //求职意向的数量
      imgList3:[],
      fileUpload: reqest.apiUrl+'/Home/Publicother/uplodadLogo',
      shareWxQr: '',
      shareLink: '',
      showShare: false,
      language: language(),
      lan: Cookies.get("lang"),
      loading: true,
      ticketMan: true,  //门票管理的表格
      pageTotal: 0,
      pageSize: 6,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      //搜索相关
      ExhIndexType,
      searchInputPlc: pubLanguage.fairName,
      searchSelectPlc: pubLanguage.state,
      //搜索条件
      getStateCon: null,
      getValCon: null,
      //table 表头
      columns: [
        {
          title: pubLanguage.ticName,
          key: "exh_name",
          width: "200",
        },
        {
          title: pubLanguage.exhibitionTime,
          key: "exh_time",
          width: "300",
        },
        {
          title: pubLanguage.price,
          key: "exhticket_price",
          width: "120",
        },
        {
          title: pubLanguage.buyTime,
          key: "pay_time",
          width: "160",
        },
        {
          title: pubLanguage.operation,
          key: "action",
          width: "200",
        },
      ],
      ticktsData: [],
      cloneTicktsData: [],
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.city = this.userInfo.location.split(" ");
    this.loadData();
    if(this.userInfo.resume_file){
      this.imgList3 = [{ status: "success", url: this.userInfo.resume_file }];
    }else{
      this.imgList3 = [];
    }
    console.log("信息" , this.userInfo);
  },

  mounted(){
    this.$refs.resumeInfo.loadData(this.userInfo);
  },
  methods: {
    openResumefile(){
      if(this.userInfo.resume_file){
        window.open(this.userInfo.resume_file);
      }else{
        const height = document.body.clientHeight / 2;
        this.$message.error({message: '请先上传简历', offset: height})
      }
    },
    toUserInfo() {
      window.location.href = "user.html";
    },
    addThink() {
      window.location.href = "user.html#/jobList";
    },
    addJob() {
      window.location.href = "user.html#/jobList";
    },
    loadData() {
      /*let data = {
        token: this.$store.state.user.token,
        // currentPage: this.currentPage,
        // numberPage: this.pageSize,
        user_id: this.userInfo.user_id,
        // city: this.fromData.city,
        // salary: this.fromData.salary,
        // classify: this.fromData.classify,
      };
      findJogList(data).then((res)=> {
          if(res.type == 1) {
            this.jobPost = res.data.list;
            this.postCount = parseInt(res.data.count);
            // this.cityPost = this.jobPost[0].city.split(" ");
          }
        console.log("求职意向" , this.jobPost);
      });*/
    },
    changeMess() {
      window.location.href = "user.html";
    },
    imgDown(url) {
      this.downloadIamge(url, '分享二维码.png')
      //location.href = url;
    },
    // 跨域文件下载
    downloadIamge(url, fileName) {
      url = url.replace(/\\/g, "/");
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      xhr.onload = () => {
        if (xhr.status == 200) {
          let data = xhr.response;
          let name = fileName;

          var urlObject = window.URL || window.webkitURL || window;
          var export_blob = new Blob([data]);
          var save_link = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "a"
          );
          save_link.href = urlObject.createObjectURL(export_blob);
          save_link.download = name;
          save_link.click();
        }
      };

      xhr.send();
    },
    updateSuccessJL(res) {
      if (res.type == "1") {
        this.userInfos.resume_file = res.data.file.picurl;
        console.log("88888:" + res.data.file.picurl);
      } else {
        if (this.lan == "ch") {
          const height = document.body.clientHeight / 2;
          return this.$message.error({ message: res.text, offset: height });
        }
        return this.$message.error({ message: res.text_en, offset: 120 });
      }
    },
    onBeforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 20;
      const height = document.body.clientHeight / 2;
      if (!isLt1M) {
        this.$message({
          showClose: true,
          message: this.language.fileMaxSize,
          type: "error",
          offset: height
        });
      }

      return isLt1M;
    },
    handleRemoveJL() {
      this.userInfos.resume_file = "";
    },
    handlePictureCardPreview(file) {
      let url = file.url;
      if(url.indexOf('.pdf')){
        window.open(file.url);
      }else{
        this.previewUrl = file.url;
        this.dialogVisible = true;
      }

    },
    recyclingClick(item){
      let _this = this;
      MessageBox({
        title: language().hint,
        message: language().takeBackTip,
        confirmButtonText: language().confirm,
        cancelButtonText: language().cancel,
        dangerouslyUseHTMLString:true,
        showCancelButton: true,
        type: 'warning'
      }).then(() => {
        //确认
        _this.recyclingOk(item.exhticket_user_id);
      }).catch(() => {
        //取消
      });
    },
    recyclingOk(id) {
      let data = {
        token: this.$store.state.user.token,
        exhticket_user_id: id
      };
      ExhticketRecovery(data).then(res => {
        if (res.type == "1") {
          this.exhTicketList();
        } else {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({message: res.text, offset: height})
          }
          return this.$message.error({message: res.text_en, offset: 120})
        }
      });
    },
    updateVisiable(e){
      this.showShare = e;
    },
    copyPcUrl() {
      let url = this.shareLink;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      const height = document.body.clientHeight / 2;
      this.$message({
        message: this.lan == 'ch'?"复制成功":"Copy succeeded",
        type: "success",
        offset:height
      });
      oInput.remove();
    },
    //复制票号
    copyNum(numData) {
      let copyData = numData.exhticketNum;
      this.copy(copyData);
    },
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      //console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      const height = document.body.clientHeight / 2;
      this.$message({
        message: this.lan == 'ch'?"复制成功":"Copy succeeded",
        type: "success",
        offset: height,
      });
      oInput.remove();
    },
    //搜索切换
    toSearch(state, val) {
      this.getStateCon = state;
      this.getValCon = val;
      this.currentPage = 1;
      this.exhTicketList();
    },
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.exhTicketList();
    },
    //展会门票列表
    exhTicketList() {
      let that = this;
      let data = {
        token: this.$store.state.user.token,
        type: this.getStateCon,
        lan: this.lan,
        keyword: this.getValCon,
        currentPage: this.currentPage,
        numberPage: this.pageSize,
      };
      getGzExhTicketList(data).then((res) => {
        if (res.type != "1") {
          if (this.lan == "ch") {
            const height = document.body.clientHeight / 2;
            return this.$message.error({ message: res.text, offset: height });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
        if (!res.data) {
          this.ticktsData = [];
          this.cloneTicktsData = [];
          this.pageTotal = 0;
          this.loading = false;
          return;
        }
        res.data.forEach((item) => {
          if (this.lan == "en") {
            item.exh_name = `${item.exh_name_en}`;
            item.exh_begtime = `${item.exh_begtime_en}`;
            item.exh_endtime = `${item.exh_endtime_en}`;
            item.pay_time = `${item.pay_time_en}`;
          }
          item.exh_time = `${item.exh_begtime} ${this.language.to} ${item.exh_endtime}`;
          item.exhticket_price = `${item.exhticket_price}${this.language.CNY}/${this.language.site1}`;
        });
        this.ticktsData = res.data;
        this.cloneTicktsData = res.data;
        this.pageTotal = Number(res.datacount);
        this.loading = false;
      });
    },
    //下载谷歌浏览器
    download() {
      window.open(
        "https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds"
      );
    },
    shareClick(data){
      let encodeData = window.btoa(window.encodeURIComponent("exhticket_user_id="+data.dataList.exhticket_user_id));
      this.showShare = true;
      let nowUrl = location.href.substring(0, location.href.lastIndexOf('.html'));
      nowUrl = nowUrl.substring(0, nowUrl.lastIndexOf('/'));
      this.shareLink = nowUrl+"/shareExhticket.html?"+encodeData;
      this.shareWxQr = reqest.adminapi+'MakeQr/getShareTicketQr?exhticket_user_id='+data.dataList.exhticket_user_id;
    },
    getJoin(data) {
      window.location.href =
        "forum.html" + "?exhibition_id=" + data.dataList.exhibition_id;
    },
  },
};
</script>

<style scoped>
.el-button{
  line-height: 6px;
}
.exhibitionRecord >>> .tableNode {
  padding: 30px 20px;
  border-radius: 5px;
}
.exhibitionRecord >>> .ji-tip {
  padding: 20px 27px 25px 30px;
  background: #FFFFFF;
  /*margin-bottom: 5px;*/
  margin-top: 0;
  border-radius: 5px;
}
.exhibitionRecord >>> .ji-tip .prompt-info {
  height:30px;
  line-height:30px;
  color:#f47900;
  font-size:18px;
  padding-left: 0;
  font-weight:bold;
}
.prompt-info span {
  color: #0071ff;
  cursor: pointer;
}
.exhibitionRecord >>> .infoPub .tableNode {
  border-radius: 5px;
}

.pc-url-div {
  margin: 30px auto;
  width: 800px;
  height: 80px;
  line-height: 80px;
  border-radius: 10px;
  background: #ececec;
  color: #000;
  display: block;
  padding: 0px 50px;
  /* margin: 0 auto; */
}
.share-title{
  padding: 0px 10px;
  font-weight:bold;
  border-left: 5px solid #0c6dce;
  font-size:18px;
}
.share-img{
  display: block;
  height: 150px;
  width: auto;
  margin: 0px auto;
}

.url-formBtn{
  border-bottom:1px solid #eee;
  padding-bottom:20px;
  margin-bottom:10px;
}
.jl-content {
  width: 950px;
  /*height: 1175px;*/
  background-color: #ffffff;
  border-radius: 5px;
  margin-top: 10px;
  padding: 20px 20px 60px 20px;
}
.jl-mess {
  width: 950px;
  height: 120px;
  /*border: 1px solid #333333;*/
  display: flex;
}
.ji-mess-tx {
  flex: 0.8;
  /*border: 1px solid #333333;*/
  height: 120px;
  line-height: 120px;
  text-align: right;
  position: relative;
  top: 10px;
  padding-right: 10px;
}
.ji-mess-xx {
  flex: 3;
  /*border: 1px solid #333333;*/
  font-family: SourceHanSansCN-Bold;
  padding-top: 10px;
  padding-left: 10px;
}

.ji-mess-btn {
  flex: 1;
  /*border: 1px solid #333333;*/
  height: 120px;
  line-height: 120px;
  text-align: right;
  padding-right: 20px;
}
.jl-jobPurpose {
  width: 950px;
  min-height: 120px;
  /*border: 1px solid #333333;*/
  padding: 15px 20px;
}
.jl-jobEducation {
  width: 950px;
  min-height: 90px;
  /*border: 1px solid #333333;*/
  padding: 15px 20px;
  position: relative;
}
.jl-jobTitle {
  /*width: 81px;*/
  /*height: 20px;*/
  font-family: SourceHanSansCN-Bold;
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  color: #333333;
  margin-left: 30px;

}
.jl-jobnr {
  width: 874px;
  height: 108px;
  line-height: 108px;
  text-align: center;
  background-color: #f5f6f7;
  border: solid 1px #d9d9d9;
  border-radius: 5px;
  /*border: solid 1px #d9d9d9;*/
  margin-left: 30px;
  margin-top: 10px;
  color: #808080;
  font-size: 18px;
  cursor: pointer;
}
.jl-jobname {
  margin-top: 10px;
  padding-left: 30px;
}
</style>
